import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import styles from './styles.scss';



const TeachSection: FC<{}> = (props) => {
	const { width } = useResizeObserver();
	const { transData } = useTranslation('tutors.teach');

	return (
		<section className={styles['ac-teach']} id='teach'>
			{width >= 1192 && <div className={styles['ac-teach-container']}>
				<div className={styles['teach-img']}>
					<img className={styles['teach-img-1']} loading='lazy' src="https://web-data.zmlearn.com/image/kRRHPFQH8p1WBYuzfXpi1n/img_p2%402x.png" alt="" />
					<img className={styles['teach-img-2']} src="https://web-data.zmlearn.com/image/BaF9oaJmjpwmCC2xUxUt3/img_p1%402x.png" alt="" />
				</div>
				<div className={styles['ac-teach-content']}>
					<div dangerouslySetInnerHTML={{ __html: transData.title }} />
					<p>{transData.desc}</p>
				</div>
			</div>}
			{width < 1192 && <div className={styles['ac-teach-container']}>
				<div dangerouslySetInnerHTML={{ __html: transData.title }} />
				<div className={styles['teach-img']}>
					<img className={styles['teach-img-1']} loading='lazy' src="https://web-data.zmlearn.com/image/kRRHPFQH8p1WBYuzfXpi1n/img_p2%402x.png" alt="" />
					<img className={styles['teach-img-2']} src="https://web-data.zmlearn.com/image/BaF9oaJmjpwmCC2xUxUt3/img_p1%402x.png" alt="" />
				</div>
				<p>{transData.desc}</p>
			</div>}
		</section>
	);

}

export default TeachSection
